import Schedule from "../../components/customer/schedule/schedule";

const SchedulePage = () => {
  return <Schedule />;
};

export default SchedulePage;

